import { createSelector } from 'reselect'
// import { List } from 'immutable'

const standardCostPriceSelector = state => state.get('standardCostPrice')

export const getIsFetching = createSelector(
  standardCostPriceSelector,
  sstandardCostPriceImmutable => {
    const subcontractCost = sstandardCostPriceImmutable.toJS()
    return subcontractCost.standardCostPriceGet.isFetching
    || subcontractCost.standardCostPriceCreate.isFetching
    || subcontractCost.standardCostPriceEdit.isFetching
    || subcontractCost.standardCostPriceExport.isFetching
  }
)
export const getStandardCostPriceData = createSelector(
  standardCostPriceSelector,
  sstandardCostPriceImmutable => {
    const subcontractCost = sstandardCostPriceImmutable.toJS()
    return subcontractCost.standardCostPriceGet
  }
)
export const createStandardCostPriceData = createSelector(
  standardCostPriceSelector,
  sstandardCostPriceImmutable => {
    const subcontractCost = sstandardCostPriceImmutable.toJS()
    return subcontractCost.standardCostPriceCreate
  }
)
export const editStandardCostPriceData = createSelector(
  standardCostPriceSelector,
  sstandardCostPriceImmutable => {
    const subcontractCost = sstandardCostPriceImmutable.toJS()
    return subcontractCost.standardCostPriceEdit
  }
)
export const exportStandardCostPriceData = createSelector(
  standardCostPriceSelector,
  sstandardCostPriceImmutable => {
    const subcontractCost = sstandardCostPriceImmutable.toJS()
    return subcontractCost.standardCostPriceExport.url
  }
)
export const redirectStandardCostPrice = createSelector(
  standardCostPriceSelector,
  sstandardCostPriceImmutable => {
    const subcontractCost = sstandardCostPriceImmutable.toJS()
    return ({
      redirect: (subcontractCost.standardCostPriceGet.redirect
      || subcontractCost.standardCostPriceCreate.redirect
      || subcontractCost.standardCostPriceEdit.redirect
      || subcontractCost.standardCostPriceExport.redirect),
      isAuthenticated: (subcontractCost.standardCostPriceGet.isAuthenticated
      || subcontractCost.standardCostPriceCreate.isAuthenticated
      || subcontractCost.standardCostPriceEdit.isAuthenticated
      || subcontractCost.standardCostPriceExport.isAuthenticated),
    })
  }
)




// WEBPACK FOOTER //
// ./src/selectors/standard-cost-price/standard-cost-price-selector.js